module.exports = __webpack_public_path__ + "static/storefront-130db7769556d920b02008170cf0d696.jpg";